import { render, staticRenderFns } from "./ProductDesignViewDetail.vue?vue&type=template&id=7470e092&"
import script from "./ProductDesignViewDetail.vue?vue&type=script&lang=js&"
export * from "./ProductDesignViewDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports